import { Banner } from "@app/scripts/types";
import React from "react";

type Props = {
  banner: Banner;
};

export const CartBanner: React.FC<Props> = ({ banner }) => {
  if (!banner) {
    return null;
  }

  if (banner.link) {
    return (
      <a className="cart__inline-banner" href={banner.link} title={banner.alt}>
        <img src={banner.image} alt={banner.alt}></img>
      </a>
    );
  }

  return (
    <div className="cart__inline-banner">
      <img src={banner.image} alt={banner.alt}></img>
    </div>
  );
};
